import { MediaType } from 'src/app/utils/media-type';

export interface DigitalSessionEventDTO {
  Id: string;
  AttachData?: any;
  SessionDirection: DigitalSessionDirection;
  SessionEventType: DigitalSessionEventType;
  SessionEndReason?: DigitalSessionEndReason;
  contactId?: string;

  mediaType: MediaType;
}

export enum DigitalSessionDirection {
  Inbound,
  Outbound,
}

export enum DigitalSessionEventType {
  Assigned,
  Unassigned,
}

export enum DigitalSessionEndReason {
  Closed,
  Transfered,
}
